import React from "react";
import { Link } from "react-router-dom";
import AlbetheineEye from "@/components/AlbetheineEye";

export default function Header() {
  return (
    <header
      className="sticky top-0 z-40 bg-charcoal/85 backdrop-blur-md border-b border-[rgba(201,169,97,0.18)]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="header-home-link"
        >
          <AlbetheineEye size={36} />
          <div className="leading-none">
            <div className="brand-name text-cream text-xl md:text-2xl">
              Tapped In Clarity
            </div>
            <div className="font-cinzel text-[0.6rem] md:text-[0.65rem] text-gold tracking-[0.4em] mt-1">
              ALBETHEINE&apos;S ORACLE
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-cinzel text-[0.72rem] tracking-[0.24em] uppercase">
          <a
            href="/#whispers"
            className="text-cream-soft hover:text-gold-bright transition-colors"
            data-testid="nav-whispers"
          >
            Whispers
          </a>
          <a
            href="/#offerings"
            className="text-cream-soft hover:text-gold-bright transition-colors"
            data-testid="nav-offerings"
          >
            Offerings
          </a>
          <a
            href="/#pricing"
            className="text-cream-soft hover:text-gold-bright transition-colors"
            data-testid="nav-pricing"
          >
            Pricing
          </a>
          <a
            href="/#founders-circle"
            className="text-cream-soft hover:text-gold-bright transition-colors"
            data-testid="nav-founders"
          >
            Founder&apos;s Circle
          </a>
          <Link
            to="/contact"
            className="text-cream-soft hover:text-gold-bright transition-colors"
            data-testid="nav-contact"
          >
            Contact
          </Link>
        </nav>

        <a
          href="mailto:tappedinclarity@gmail.com"
          className="btn-ghost hidden sm:inline-flex"
          data-testid="header-cta-email"
        >
          Get In Touch
        </a>
      </div>
    </header>
  );
}
